/* This is a the Sample Section */


import React, {useEffect,useState} from 'react';
import {initialize, reduxForm} from 'redux-form';
import "../../../css/query-view.css";
import { useTranslation } from "react-i18next";

import {connect} from 'react-redux'
import {SelectArea} from "../../../../../../../../../../gpap-lib/components/shared-components/renderer";

import * as VARIANT_CONFIG from "./variantConfig";
import {dict_classes_variants} from "./variantConfig";

import MappedText from '../../../../../../../../../study-page/create-study/analysis-page/components/clinical-info/mapText';
import {GPAP_Button_Light} from "../../../../../../../../../../gpap-lib/components/Button_Collection";


let Variant_Section = props => {
    const { t } = useTranslation();
    const { handleSubmit, pristine, submitting, minimized } = props;
    const translatedVariantClass = VARIANT_CONFIG.variant_class.map(item => ({
        ...item,
        label: t(item.label)
    }));
    const translatedTaggedVariants = VARIANT_CONFIG.tagged_variants.map(item => ({
        ...item,
        label: t(item.label)
    }));
    const translatedManeSelect = VARIANT_CONFIG.mane_select.map(item => ({
        ...item,
        label: t(item.label)
    }));
    const translatedTranscript = VARIANT_CONFIG.transcript.map(item => ({
        ...item,
        label: t(item.label)
    }));
    const translatedVariantType = VARIANT_CONFIG.variant_type.map(item => ({
        ...item,
        label: t(item.label)
    }));
    const translatedClinVar = VARIANT_CONFIG.clinvar.map(item => ({
        ...item,
        label: t(item.label)
    }));

    const tooltips = {
        variantclasses:  <div><span><MappedText text="SnpEff reports putative variant impact in order to make it easier quickly to categorize and prioritize variants. As defined by SnpEFF - see " /><a style={{color: "orange" }} href="https://pcingola.github.io/SnpEff/se_inputoutput/#impact-prediction" target="_blank"><MappedText text="Effect prediction details" />"</a><MappedText text=" section for a detailed explanation" /></span></div>,
        v_tagged: t("When applied,it will return variants that have been tagged only in the GPAP database"),
        variantconsequences:<div><span><MappedText text="Ensembl Variation - Calculated variant consequences . see " /><a style={{color: "orange" }} href="https://www.ensembl.org/info/genome/variation/prediction/predicted_data.html" target="_blank"><MappedText text="Effect prediction details" /></a></span></div>,
        mane:<div><span><MappedText text="MANE Select is the transcript agreed as universal standard for clinical reporting, NCBI - WWW Error Blocked Diagnostic " /><a style={{color: "orange" }} href="https://www.ncbi.nlm.nih.gov/refseq/MANE/" target="_blank"><MappedText text="NCBI MANE" /></a></span></div>,
        clinvarclasses: t("ClinVar aggregates information about genomic variation and its relationship to human health"),
    };
    const resetSection = () =>{

        let reset_obj = {
            "clinvarclasses": [],
            "variantclasses": [],
            "genotypefeatures": [],
            "v_tagged": [],
            "v_type": [],
            "Mane": [],
            "variantconsequences": []

        };
        props.dispatch(initialize(
            'variants',
            reset_obj
        ));



    };


    const [init_obj_statefull, setinit_obj] = useState({});
    useEffect(function(){

        function addToArray(target, key, value, label) {
            if (!Array.isArray(target[key])) {
                target[key] = [];
            }
            if (!target[key].some(el => el.value === value)) {
                target[key] = [...target[key], { value, label }];
            }
        }

        if((props.default_filters!== undefined))
             {
          if(props.default_filters){
              let obj = {...props.default_filters};
              let keys = Object.keys(obj);
              let init_obj = {};
              keys.forEach(function(key){
                  let options = dict_classes_variants[key];
                  // Helper function to add or initialize an array


                  switch (key) {
                      case "variant_type":
                          if (obj["variant_type"]) {
                              const val = [];
                              if (obj["variant_type"] === "selected_samples") {
                                  val.push({ value: "selected", label: "Selected samples" });
                              } else if (obj["variant_type"] === "all_samples") {
                                  val.push({ value: "any", label: "Any Sample" });
                              }
                              init_obj["v_tagged"] = val;
                          }
                          break;

                      case "indel":
                          if (obj["indel"]) {
                              addToArray(init_obj, "v_type", "indel", "INDEL");
                          }
                          break;

                      case "svn":
                          if (obj["svn"]) {
                              addToArray(init_obj, "v_type", "snv", "SNV");
                          }
                          break;

                      case "Mane":
                          if (obj["Mane"]) {
                              addToArray(init_obj, "Mane", "Mane", "Mane");
                          }
                          break;

                      default:
                          const vals = obj[key];
                          if (vals && typeof vals === "object") {
                              const trues = Object.keys(vals).filter(k => vals[k]);
                              if (options !== undefined) {
                                      const selectedOptions = options.filter(opt => trues.includes(opt.value));
                                      init_obj[key] = selectedOptions.map(opt => ({...opt, label: t(opt.label)}));
                                   }
                               }
                               break;
                  }

              });
              //check if we are tyring to rerender the same form that has been already rendered, for some reason the first time you try to modify a filter, it is fired again and it puts the filter in the form again
              if ( JSON.stringify(init_obj_statefull) !== JSON.stringify(init_obj)){
                console.log("dispatch action");
              
              setinit_obj(init_obj);
              if(Object.keys(init_obj).length>0){
                  props.dispatch(initialize(
                      'variants',
                      init_obj,
                  ));
              }}
          }
          else{ // case in which I reset .. TODO : review this

              resetSection();

          }
        }

    },[props.default_filters]);


    const renderAll = ( ) => {

        return <React.Fragment>

            <SelectArea collection_name={'v_type'}
                header='Variant Type'
                fields={translatedVariantType}  />
            <SelectArea collection_name={'v_tagged'}
                tooltip={tooltips["v_tagged"]}
                header='Tagged Variants'
                fields={translatedTaggedVariants} />
            <SelectArea collection_name={'genotypefeatures'} header='Transcript Biotype' fields={translatedTranscript} />
            {(window.config.genome_ref === "hg38") && (<SelectArea collection_name={'Mane'}
                header='Mane'
                tooltip={tooltips["mane"]}
                fields={translatedManeSelect}  />)}


        </React.Fragment>


    };


    return (
        <div className={"form_section"}>
            <div className={'bar'}>
                <GPAP_Button_Light size="sm" variant={"gpap_button"} disabled={ pristine || submitting } onClick={ () => resetSection()}>
                    <MappedText text={"Clear Filters"}/>
                </GPAP_Button_Light>
            </div>
            <form onSubmit={handleSubmit}>
                <div className={"form_container"}>
                <SelectArea collection_name={'variantclasses'}
                            header = 'Protein Impact'
                            fields = {translatedVariantClass}
                            tooltip={tooltips["variantclasses"]}

                />
                <SelectArea collection_name={'variantconsequences'}
                            header = 'Variant Consequence'
                            fields = {VARIANT_CONFIG.variant_consequences_class}
                            tooltip={tooltips["variantconsequences"]}

                />
                <SelectArea collection_name={'clinvarclasses'}
                            tooltip={tooltips["clinvarclasses"]}
                            header = 'ClinVar Classification'
                            fields = {translatedClinVar}/>
                    { (minimized) ? null : renderAll() }
                </div>
            </form>
        </div>
    )
};




export default reduxForm({
    form: 'variants', // a unique identifier for this form
    destroyOnUnmount: true, // this allows to keep the values even if you switch from one tab to another
    enableReinitialize : true,
    keepDirtyOnReinitialize: true,
    updateUnregisteredFields: true,
    initialValues: {
        "clinvarclasses": [],
        "variantclasses": [],
        "genotypefeatures": [],
        "v_tagged": [],
        "v_type": [],
        "Mane": [],
        "variantconsequences": []

    }
})(Variant_Section)


// Connect your component and map form values to props

  



Variant_Section = connect(() => ({}))(Variant_Section);
